import { render, staticRenderFns } from "./qualityCourseOrder.vue?vue&type=template&id=512f6e83&scoped=true"
import script from "./qualityCourseOrder.vue?vue&type=script&lang=js"
export * from "./qualityCourseOrder.vue?vue&type=script&lang=js"
import style0 from "./qualityCourseOrder.vue?vue&type=style&index=0&id=512f6e83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512f6e83",
  null
  
)

export default component.exports